import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-info-alert',
  standalone: true,
  templateUrl: './info-alert.component.html',
  styleUrls: ['./info-alert.component.css'],
})
export class InfoAlertComponent {
  @Input() title: string = '';
}
